(() => {
  'use strict';

  function formatMoney(cents, format) {
    const value = Number(cents) / 100;
    const withDelims = (n, decimals, thousands, decimal) => {
      const parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    };
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  // Formats cents in the visitor's currency, using a sample rendered by Liquid (1234.56 in that currency).
  const SAMPLE = /^([\s\S]*?)1(\D?)234(\D)56([\s\S]*)$/.exec(window.nbMoneySample || '');
  function money(cents, opts) {
    if (!SAMPLE) return formatMoney(cents);
    const [, pre, th, dec, suf] = SAMPLE;
    const parts = (Number(cents) / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    const num = opts && opts.whole && parts[1] === '00' ? parts[0] : parts[0] + dec + parts[1];
    return pre + num + suf;
  }

  // Free-shipping amounts are set in the shop currency (EUR); convert them for visitors paying in another currency.
  const rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
  const fsThreshold = (baseCents) => Math.ceil((Number(baseCents) * rate) / 100) * 100;
  document.querySelectorAll('[data-fs-tpl]').forEach((el) => {
    el.textContent = el.dataset.fsTpl.replace('__FS__', money(fsThreshold(el.dataset.fsBase), { whole: true }));
  });
  document.querySelectorAll('[data-fs-bar]').forEach((bar) => {
    const threshold = fsThreshold(bar.dataset.fsBase);
    const total = Number(bar.dataset.cartTotal);
    const left = threshold - total;
    const txt = bar.querySelector('[data-fs-text]');
    const fill = bar.querySelector('[data-fs-fill]');
    if (txt) txt.textContent = left > 0 ? bar.dataset.tplLeft.replace('__FS__', money(left)) : bar.dataset.tplOk;
    if (fill) fill.style.width = Math.min(100, Math.floor((total * 100) / threshold)) + '%';
  });

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    if (nav) nav.hidden = open;
  });
  document.querySelectorAll('[data-autosubmit]').forEach((el) => {
    el.addEventListener('change', () => el.form && el.form.submit());
  });

  document.querySelectorAll('[data-pdp]').forEach((root) => {
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const form = root.querySelector('[data-buy-form]');
    const variantInput = root.querySelector('[data-variant-input]');
    const qtyInput = root.querySelector('[data-qty-input]');
    const priceEl = root.querySelector('[data-price]');
    const addBtn = root.querySelector('[data-add-btn]');
    const addLabel = root.querySelector('[data-add-label]');
    const stickyBtn = root.querySelector('[data-sticky-btn]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const packs = root.querySelector('[data-packs]');
    let variant = data.variants.find((v) => String(v.id) === variantInput.value) || data.variants[0];
    const fmt = (c) => (SAMPLE ? money(c) : formatMoney(c, data.moneyFormat));

    function selectedQty() {
      const checked = root.querySelector('[data-pack-qty]:checked');
      return checked ? Number(checked.value) : 1;
    }

    let displayedVariantId;
    function render() {
      if (displayedVariantId !== variant.id) {
        syncVariantMedia();
        displayedVariantId = variant.id;
      }
      if (packs) {
        root.querySelectorAll('[data-pack-qty]').forEach((input) => {
          const q = Number(input.dataset.packQty);
          const pct = Number(input.dataset.packPct || 0);
          const full = variant.price * q;
          const disc = Math.floor((full * (100 - pct)) / 100);
          const label = input.closest('.pack');
          const p = label.querySelector('[data-pack-price]');
          const f = label.querySelector('[data-pack-full]');
          if (p) p.textContent = fmt(disc);
          if (f) f.textContent = fmt(full);
        });
      }
      const q = selectedQty();
      qtyInput.value = q;
      variantInput.value = variant.id;
      const native = root.querySelector('[data-native-variant]');
      if(native) native.value = variant.id;
      if (priceEl) priceEl.textContent = fmt(variant.price);
      const checkedPack = root.querySelector('[data-pack-qty]:checked');
      const pct = checkedPack ? Number(checkedPack.dataset.packPct || 0) : 0;
      const total = Math.floor((variant.price * q * (100 - pct)) / 100);
      if (stickyPrice) stickyPrice.textContent = fmt(total);
      const validQuantities = !variant.quantity_rule || q >= variant.quantity_rule.min && (q - variant.quantity_rule.min) % variant.quantity_rule.increment === 0 && (!variant.quantity_rule.max || q <= variant.quantity_rule.max);
      const ok = variant.available && validQuantities;
      [addBtn, stickyBtn].forEach((b) => { if (b) b.disabled = !ok; });
      if (addLabel) addLabel.textContent = ok ? data.buyNow : data.soldOut;
      if (stickyBtn) stickyBtn.textContent = ok ? data.buyNow : data.soldOut;
    }

    root.classList.add('pdp--enhanced');
    root.querySelector('[data-native-variant]')?.addEventListener('change', event => {
      const match = data.variants.find(v => String(v.id) === event.target.value);
      if(match) { variant = match; render(); }
    });
    root.querySelectorAll('[data-option-index]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const selected = [];
        root.querySelectorAll('[data-option-index]:checked').forEach((r) => {
          selected[Number(r.dataset.optionIndex)] = r.value;
        });
        const match = data.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        if (match) {
          variant = match;
          const cur = root.querySelector('[data-option-current="' + radio.dataset.optionIndex + '"]');
          if (cur) cur.textContent = radio.value;
          const url = new URL(window.location.href);
          if (url.pathname.includes('/products/')) {
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url.toString());
          }
          render();
        }
      });
    });

    root.querySelectorAll('[data-pack-qty]').forEach((r) => r.addEventListener('change', render));

    const track = root.querySelector('[data-gallery-track]');
    const thumbs = root.querySelectorAll('[data-thumb]');
    function syncVariantMedia() {
      const mediaId = data.variantMedia?.[String(variant.id)] || variant.featured_media?.id;
      if (!mediaId) return;
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const index = slides.findIndex(slide => slide.dataset.mediaId === String(mediaId));
      if (index < 0) return;
      goTo(index);
      const image = slides[index].querySelector('img');
      const stickyImage = root.querySelector('.sticky-buy__img');
      if (image && stickyImage) {
        stickyImage.src = image.currentSrc || image.src;
        stickyImage.removeAttribute('srcset');
      }
    }

    function goTo(i) {
      const slides = root.querySelectorAll('[data-slide]');
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    if (track && thumbs.length) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
        });
      }, { passive: true });
    }

    if (form) {
      form.addEventListener('submit', () => {
        [addBtn, stickyBtn].forEach((b) => { if (b) b.setAttribute('aria-busy', 'true'); });
      });
    }

    const sticky = root.querySelector('[data-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      const io = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
      });
      io.observe(addBtn);
    }

    render();
  });

  document.querySelectorAll('[data-cart-qty]').forEach((input) => {
    let t;
    input.addEventListener('change', () => {
      clearTimeout(t);
      t = setTimeout(() => input.form && input.form.submit(), 350);
    });
  });
})();

